import React from 'react';
import { useTranslation } from '~/dependencies';
import { NewSession } from '~/components/ActiveCall/types';
import { IconGroup } from '~/assets/svgIcons';
import { ReactSVG } from './styles';

type ConferenceButtonProps = {
  onClick: (session: NewSession) => void;
  session: NewSession;
};

const Conference = ({ onClick, session }: ConferenceButtonProps) => {
  const {
    answered,
    callActions: { conference: isConferenceOpened },
  } = session;

  const { t } = useTranslation();

  function clickHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    onClick(session);
  }

  return (
    <button
      type="button"
      title={t('components.activeCalls.btn.conference')}
      disabled={!answered}
      onClick={clickHandler}>
      <ReactSVG src={IconGroup} selected={isConferenceOpened} />
    </button>
  );
};

export default Conference;
